import { BookingLogsModel } from "app/models";
import { BookingLogState } from "app/reducers/bookingLog";
import { schedulingFetchGet } from "app/utils/request/scheduling/fetch";
import { Dispatch } from "react";
import { action, ActionType } from "typesafe-actions";

const fetchSuccess = (bookingLog: BookingLogsModel[]) =>
  action("@bookingLog.fetch.success", bookingLog);
const fetchPending = () => action("@bookingLog.fetch.pending");
const fetchError = (err: string) => action("@bookingLog.fetch.error", err);
export const hasMore = (hasMore: boolean) =>
  action("@bookingLog.fetch.hasMore", hasMore);
export const currentPage = (currentPage: number) =>
  action("@bookingLog.fetch.currentPage", currentPage);
export const clear = () => action("@bookingLog.clear");

const thisActions = {
  fetchPending,
  fetchError,
  fetchSuccess,
  hasMore,
  currentPage,
  clear,
};

export type BookingLogAction = ActionType<typeof thisActions>;

export const fetchBookingLogs = (
  params?: { [key: string]: any },
  signal?: AbortSignal,
) => {
  return async (
    dispatch: Dispatch<BookingLogAction>,
    getState?: () => BookingLogState,
  ) => {
    dispatch(fetchPending());

    const page = getState()?.currentPage || 1;

    try {
      const response: any = await schedulingFetchGet(
        "/booking_logs",
        params || {},
        { withHeaders: true },
        signal
      );

      if (response?.students?.length < params?.perPage) {
        dispatch(hasMore(false));
      }

      dispatch(currentPage(page + 1));
      dispatch(fetchSuccess(response));

      return response;
    } catch (error) {
      console.error("Failed to fetch booking logs:", error);
      dispatch(fetchError(error));
      throw error;
    }
  };
};
